import { TopicsService } from "@/services/CoachingServices";
import TopicEditor from "@/components/training/topics/TopicEditor.vue";
import ScenarioEditor from "@/components/training/scenarios/ScenarioEditor.vue";
import topicScenarioLoader from "./topicScenarioLoader";

export default {
  mixins: [topicScenarioLoader],

  components: {
    TopicEditor,
    ScenarioEditor,
  },

  data() {
    return {
      isTopicEditorActive: false,
      isScenarioEditorActive: false,
      topicToEdit: null,
      scenarioToEdit: null,
      currentPgnToEdit: "",
    };
  },

  methods: {
    // Topic management
    handleCreateTopic() {
      this.topicToEdit = null;
      this.isTopicEditorActive = true;
    },

    handleEditTopic(topic) {
      this.topicToEdit = topic;
      this.isTopicEditorActive = true;
    },

    closeTopicEditor() {
      this.isTopicEditorActive = false;
      this.topicToEdit = null;
    },

    async handleTopicSaved(topic) {
      this.closeTopicEditor();
      await this.loadTopics();

      if (this.selectedTopicId === topic.id) {
        await this.loadScenarios(topic.id);
      }

      this.$buefy.toast.open({
        message: "Topic saved successfully",
        type: "is-success",
      });

      this.$emit("topicSaved", topic);
    },

    // Scenario management
    handleCreateScenario(initialPgn = "") {
      if (!this.selectedTopicId) {
        this.$buefy.toast.open({
          message: "Please select a topic first",
          type: "is-warning",
        });
        return;
      }
      this.scenarioToEdit = null;
      this.currentPgnToEdit = initialPgn;
      this.isScenarioEditorActive = true;
    },

    handleEditScenario(scenario, pgn = null) {
      this.scenarioToEdit = scenario;
      this.currentPgnToEdit = pgn || scenario?.pgn || "";
      this.isScenarioEditorActive = true;
    },

    closeScenarioEditor() {
      this.isScenarioEditorActive = false;
      this.scenarioToEdit = null;
      this.currentPgnToEdit = "";
    },

    async handleSaveScenarioToTopic(data) {
      try {
        const topicId = data.topicId || this.selectedTopicId;
        const result = await TopicsService.importScenarios(topicId, data.pgn);

        if (result.created.length > 0) {
          // Refresh scenarios cache for the affected topic
          const scenarios = await this.fetchScenarios(topicId);
          this.scenariosCache.set(topicId, scenarios);

          // Select the first created scenario
          // this.handleSelectScenario(result.created[0].id);
          // await this.handleSelectTopic(this.selectedTopicId);
          // await this.loadScenarios(this.selectedTopicId);
        }

        const message =
          `Created ${result.created.length} new example${
            result.created.length > 1 ? "s" : ""
          }` +
          (result.existing.length
            ? `. (${result.existing.length} already existed)`
            : "");

        this.$buefy.toast.open({
          message,
          type: result.created.length ? "is-success" : "is-warning",
        });

        this.closeScenarioEditor();
        this.$emit("scenarioSaved", result);
      } catch (error) {
        console.error("Error creating scenarios:", error);
        this.$buefy.toast.open({
          message: "Failed to create scenarios",
          type: "is-danger",
        });
      }
    },

    async handleUpdateScenario(data) {
      try {
        const updatedScenario = await TopicsService.updateScenario(
          data.topicId,
          data.scenarioId,
          {
            pgn: data.pgn,
            status: data.status,
            order: data.order,
          }
        );

        // Refresh scenarios cache for the affected topic
        const scenarios = await this.fetchScenarios(data.topicId);
        this.scenariosCache.set(data.topicId, scenarios);
        await this.loadScenarios(this.selectedTopicId);

        this.$buefy.toast.open({
          message: "Scenario updated successfully",
          type: "is-success",
        });

        this.closeScenarioEditor();
        this.$emit("scenarioUpdated", updatedScenario);
      } catch (error) {
        console.error("Error updating scenario:", error);
        this.$buefy.toast.open({
          message: "Failed to update scenario",
          type: "is-danger",
        });
      }
    },
  },
};
